import {usePlayers} from '@glark-newco/game-library';
import {useMemo} from 'react';
import {Tile, useGameBoard} from '../state/signlinesBoardSlice';
import {useDealtTiles} from '../state/signlinesPlayerStatsSlice';

export function useLocalPlayerTiles(): Tile[] {
    const {localPlayer} = usePlayers();

    const playedTiles = useGameBoard()
        .filter(c => !!c.tileId)
        .map(c => c.tileId!);

    const dealtTiles = useDealtTiles(localPlayer?.playerId ?? '');

    // 3️⃣  Return the tiles that are still in the hand (i.e. not yet played)
    return useMemo(() => {
        return dealtTiles
            .filter(tileId => !playedTiles.includes(tileId))
            .map(tileId => ({tileId} as Tile));
    }, [dealtTiles, playedTiles.join(',')]); // `join(',')` forces a shallow compare
}
